import ol = require("ol");
import $ = require("jquery");
import _ = require("underscore");
import MapView = require("../views/MapView");
import Utils = require("../utils");
import Portal = require("portal-gis");
import AgsDirectory = require("../utils/ags/ags-directory");
import AgsMapServer = require("../utils/ags/ags-mapserver");
import AgsLayers = require("../utils/ags/ags-layers");
import Mediator = require("../mediator");
import BaseHelper = require("./base/group-helper");

class Helper extends BaseHelper {

    create() {
        _.defaults(this.options, { layerType: "discover" });
        return super.create();
    }

    private discover(options: Rhythm.GIS.Dictionary<string> = this.options) {
        let d = $.Deferred<ol.layer.Base>();

        let layer = this.layer;
        if (layer.Layers) throw "child layers not supported for ags-dicovery layer";

        AgsDirectory.directoryService(layer.url).done(childLayers => {

            // notify api of a change to this layer
            this.merge(childLayers);

            let layers = childLayers.map(layer => this.view.createLayer(layer));

            Utils.when(layers).done(layers => {
                var group = new ol.layer.Group({
                    id: layer.id,
                    title: layer.text,
                    layers: layers,
                    visible: "false" !== options["visible"]
                });
                AgsLayers.setMinMaxZoomLevel(this.view, group, layer);
                d.resolve(group);
            });
        });

        return d;
    }

    private mapserver(options: Rhythm.GIS.Dictionary<string> = this.options) {
        let d = $.Deferred<ol.layer.Base>();

        let layer = this.layer;
        if (layer.Layers) throw "child layers not supported for ags-dicovery layer";

        AgsMapServer.mapserverService(layer.url).then(childLayers => {

            this.merge(childLayers);

            let layers = childLayers.map(layer => this.view.createLayer(layer));
            Utils.when(layers).done(layers => {
                var group = new ol.layer.Group({
                    id: layer.id,
                    title: layer.text,
                    layers: layers
                });
                AgsLayers.setMinMaxZoomLevel(this.view, group, layer);
                d.resolve(group);
            });
        });

        return d;
    }

}

class Handler {

    static about = `
Create a layer group containing all discoverable layers.

Usage Example:

    <LAYER id="arcgis-directory-service" text="Military Group" type="app/layer-factory/ags-discovery" url="http://sampleserver6.arcgisonline.com/arcgis/rest/services/Military/MapServer">
    <OPTIONS>
        <Values id="layerType" value="mapserver" />
    </OPTIONS>
    </LAYER>

    `;

    static options = {
        "layerType": {
            "about": "Query the catalog or mapserver service to produce a ol.layer.Group containing the available layers.",
            "domain": "discover|mapserver",
            "default": "discover"
        }
    }

    static create(args: {
        layer: Portal.MapLayerLeaf;
        mediator: Mediator;
        view: MapView;
    }): ol.layer.Base | JQueryDeferred<ol.layer.Base> {
        let options = Utils.asDictionary(args.layer.Options.Values);
        let helper = new Helper(args.layer, args.view, args.mediator, options);
        return helper.create();
    }

}

export = Handler; 